/**
 * Public Routes Constants
 * 
 * Centralized list of public routes that don't require authentication.
 * Used across the application to determine if a route is public or protected.
 */

/**
 * List of public routes that don't require authentication.
 * These routes are accessible without login.
 */
export const PUBLIC_ROUTES = [
  "/",
  "/pricing",
  "/subscribe",
  "/auth/login",
  "/auth/register",
  "/auth/error",
  "/terms",
  "/privacy",
  "/risk-disclaimer",
  "/support",
  "/refund-policy",
] as const;

/**
 * Check if a pathname is a public route.
 * 
 * @param pathname - The pathname to check (e.g., "/pricing", "/auth/login")
 * @returns true if the pathname is a public route, false otherwise
 */
export function isPublicRoute(pathname: string): boolean {
  return PUBLIC_ROUTES.some(
    (route) => pathname === route || pathname === `${route}/` || pathname.startsWith(`${route}?`)
  );
}

